import { render, staticRenderFns } from "./ConfirmLeave.vue?vue&type=template&id=4cb0633c&"
import script from "./ConfirmLeave.vue?vue&type=script&lang=js&"
export * from "./ConfirmLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports